export default __webpack_public_path__ + "static/media/logo_white_transparent.caff6871.png";